const getCustomPalettesToDelete = (initialCustomPalettes, currentCustomPalettes) => {
  const initialCustomPalettesIds = initialCustomPalettes.map((p) => p.id);
  const currentCustomPalettesIdsSet = new Set(currentCustomPalettes.map((p) => p.id));

  return initialCustomPalettesIds.filter((id) => !currentCustomPalettesIdsSet.has(id));
};

export default getCustomPalettesToDelete;
